import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { KeyboardArrowRight } from "@material-ui/icons";
import { Button } from "./Common";

const StyledButton = styled(Button)`
  height: 50px;
  background: transparent;
  justify-content: space-between;
  border: none;
  border-bottom: solid 1px ${({ theme }) => theme.palette.LIGHT_GREY};
  width: 100%;
  border-radius: 0;
  color: ${({ theme, selected }) =>
    selected ? theme.palette.SECONDARY : theme.palette.MEDIUM_GREY};
`;

class SideBarFilterListComp extends PureComponent {
  handleClick(item) {
    this.setState(prevState => ({ [item]: !prevState[item] }));
  }

  render() {
    const { className, handleClick, listItems, activeTab } = this.props;
    const listItemsEle = listItems.map(({ label, active }, index) => (
      <StyledButton
        key={label}
        onClick={() => handleClick(index)}
        selected={activeTab === index}
        className={className}
      >
        <span className="pos-rel">
          {label}
          {active ? <span className="active-dot" /> : null}
        </span>
        <span className="arrow-right">
          <KeyboardArrowRight />
        </span>
      </StyledButton>
    ));
    return <div>{listItemsEle}</div>;
  }
}

SideBarFilterListComp.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  listItems: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
  ),
  activeTab: PropTypes.number
};
SideBarFilterListComp.defaultProps = {
  className: "",
  handleClick: PropTypes.func,
  listItems: [],
  activeTab: 0
};

export const SideBarFilterList = styled(SideBarFilterListComp)`
  .active-dot {
    position: absolute;
    width: 10px;
    height: 10px;
    background: red;
    border-radius: 50%;
    top: 0px;
    right: -16px;
  }
  .pos-rel {
    position: relative;
  }
`;
